var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-mask",staticStyle:{"display":"none"},attrs:{"id":"loading"}},[_c('div',{staticClass:"loading-spinner"},[_c('p',{staticClass:"loading-text"},[_c('icon',{attrs:{"name":"spinner","scale":"4","pulse":""}}),_c('br'),_vm._v(" Loading, please wait... ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }